import { getRoundedFte } from '../../../resource-allocation.formatters';
import { StyledCell } from '../Row.style';

const EffortPercentCell = ({ effortPercent }) => {
  const roundEffortPercent = getRoundedFte(effortPercent);

  return <StyledCell>{roundEffortPercent}%</StyledCell>;
};

export default EffortPercentCell;
